(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  document.querySelectorAll('[data-or-article]').forEach((root)=>{const content=root.querySelector('[data-or-content]');const progress=root.querySelector('[data-or-progress]');const toc=root.querySelector('[data-or-toc]');if(!content)return;const headings=[...content.querySelectorAll('h2')];headings.forEach((heading,index)=>{if(!heading.id)heading.id=`section-${index+1}`;if(toc){const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;toc.appendChild(link)}});const update=()=>{const rect=root.getBoundingClientRect();const distance=Math.max(1,root.offsetHeight-window.innerHeight);const value=Math.min(1,Math.max(0,-rect.top/distance));if(progress)progress.style.transform=`scaleX(${value})`;let active=headings[0];headings.forEach((heading)=>{if(heading.getBoundingClientRect().top<180)active=heading});if(toc)[...toc.querySelectorAll('a')].forEach((link)=>link.classList.toggle('is-active',active&&link.hash===`#${active.id}`))};update();window.addEventListener('scroll',update,{passive:true})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.querySelectorAll('[data-or-reveal-root]').forEach((root)=>{const items=root.querySelectorAll('[data-or-reveal]');if(!('IntersectionObserver'in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){items.forEach((item)=>item.classList.add('is-visible'));return}const observer=new IntersectionObserver((entries)=>{entries.forEach((entry)=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.12});items.forEach((item)=>observer.observe(item))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["otheriver-agent-portal-suite"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-oaps-page]';

    function initialize(root) {
      if (root.dataset.oapsReady === 'true') return;
      root.dataset.oapsReady = 'true';
      root.classList.add('is-enhanced');

      const eventPrefix = 'otheriver_agent_portal_suite';
      const basePayload = { app_slug: root.dataset.appSlug, locale: document.documentElement.lang || 'en' };
      const track = (suffix, payload = {}) => {
        const eventName = `${eventPrefix}_${suffix}`;
        const detail = { event: eventName, ...basePayload, ...payload };
        window.dispatchEvent(new CustomEvent('otheriver:analytics', { detail }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detail);
      };

      root.querySelectorAll('[data-oaps-track]').forEach((element) => {
        element.addEventListener('click', () => track(element.dataset.oapsTrack, {
          placement: element.dataset.oapsPlacement || 'navigation',
          target: element.dataset.oapsTarget || element.getAttribute('href') || ''
        }));
      });

      const railLinks = Array.from(root.querySelectorAll('.oaps-rail a[href^="#"]'));
      const setActive = (href) => {
        railLinks.forEach((link) => link.removeAttribute('aria-current'));
        const active = railLinks.find((link) => link.getAttribute('href') === href);
        if (active) {
          active.setAttribute('aria-current', 'true');
          active.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      };

      railLinks.forEach((link) => {
        const href = link.getAttribute('href');
        const target = href === '#oaps-top' ? root : root.querySelector(href);
        if (!target) return;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          setActive(href);
          const destination = href === '#oaps-top' ? 0 : target.getBoundingClientRect().top + window.scrollY - 72;
          window.scrollTo({ top: Math.max(0, destination), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          window.history.replaceState(null, '', href === '#oaps-top' ? window.location.pathname + window.location.search : href);
        });
      });

      if ('IntersectionObserver' in window) {
        const anchorObserver = new IntersectionObserver((entries) => {
          const activeEntry = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!activeEntry) return;
          setActive(`#${activeEntry.target.id}`);
        }, { rootMargin: '-20% 0px -58% 0px', threshold: [0, .2, .55] });
        ['oaps-top', 'oaps-problem', 'oaps-solution', 'oaps-demo', 'oaps-pricing', 'oaps-faq'].forEach((id) => {
          const target = id === 'oaps-top' ? root : root.querySelector(`#${id}`);
          if (target) anchorObserver.observe(target);
        });

        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('is-visible', entry.isIntersecting));
        }, { threshold: .08, rootMargin: '0px 0px -5% 0px' });
        root.querySelectorAll('[data-oaps-reveal]').forEach((element) => revealObserver.observe(element));
      } else {
        root.querySelectorAll('[data-oaps-reveal]').forEach((element) => element.classList.add('is-visible'));
      }

      const demo = root.querySelector('[data-oaps-demo]');
      if (demo) {
        const buttons = Array.from(demo.querySelectorAll('[data-oaps-demo-step]'));
        const panels = Array.from(demo.querySelectorAll('[data-oaps-demo-panel]'));
        const number = demo.querySelector('[data-oaps-demo-number]');
        const progress = demo.querySelector('[data-oaps-demo-progress]');
        const heading = demo.querySelector('[data-oaps-demo-heading]');
        const copy = demo.querySelector('[data-oaps-demo-copy]');
        let started = false;

        const activateStep = (button) => {
          const step = button.dataset.oapsDemoStep;
          const index = button.dataset.oapsDemoIndex.padStart(2, '0');
          buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
          panels.forEach((panel) => { panel.hidden = panel.dataset.oapsDemoPanel !== step; });
          if (number) number.textContent = index;
          if (progress) progress.textContent = `${index} / 04`;
          if (heading) heading.textContent = button.dataset.oapsDemoTitle;
          if (copy) copy.textContent = button.dataset.oapsDemoText;
          if (!started) {
            track('demo_start', { demo_step: step });
            started = true;
          }
          track('demo_step_change', { demo_step: step, step_index: Number(button.dataset.oapsDemoIndex) });
          if (step === 'sync') track('demo_complete', { demo_step: step });
        };

        buttons.forEach((button) => button.addEventListener('click', () => activateStep(button)));
      }

      root.querySelectorAll('[data-oaps-faq]').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) track('faq_open', { faq_id: details.dataset.oapsFaq });
        });
      });

      root.querySelectorAll('[data-oaps-video]').forEach((video) => {
        video.addEventListener('play', () => track('video_play', { video_id: video.dataset.oapsVideo || 'overview' }), { once: true });
      });
    }

    document.querySelectorAll(selector).forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll(selector).forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["otheriver-checkout-fields-pro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-cfp-page]';

    function setupDemo(root) {
      const demo = root.querySelector('[data-cfp-demo]');
      if (!demo || demo.dataset.ready === 'true') return;
      demo.dataset.ready = 'true';

      const buttons = Array.from(demo.querySelectorAll('[data-cfp-persona]'));
      const panels = Array.from(demo.querySelectorAll('[data-cfp-panel]'));
      const logicInput = demo.querySelector('[data-cfp-logic-input]');
      const logicRule = demo.querySelector('[data-cfp-logic-rule]');
      const logicOutput = demo.querySelector('[data-cfp-logic-output]');
      const privateLabel = buttons.find((button) => button.dataset.cfpPersona === 'private')?.textContent.trim() || 'Private';
      const businessLabel = buttons.find((button) => button.dataset.cfpPersona === 'business')?.textContent.trim() || 'Business';

      function selectPersona(persona) {
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.cfpPersona === persona)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.cfpPanel !== persona; });
        if (logicInput) logicInput.textContent = persona === 'business' ? businessLabel : privateLabel;
        if (logicRule) logicRule.textContent = `type == ${persona}`;
        if (logicOutput) logicOutput.textContent = persona === 'business' ? 'VAT + SDI + PEC' : 'Tax code';

        const activePanel = panels.find((panel) => panel.dataset.cfpPanel === persona);
        if (activePanel && window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.gsap.fromTo(activePanel.children, { autoAlpha: 0, y: 12 }, { autoAlpha: 1, y: 0, duration: .38, stagger: .06, ease: 'power2.out' });
          window.gsap.fromTo([logicInput, logicRule, logicOutput].filter(Boolean), { color: '#8bf6ff' }, { color: '#f6f7fb', duration: .75, ease: 'power2.out' });
        }
      }

      buttons.forEach((button) => button.addEventListener('click', () => selectPersona(button.dataset.cfpPersona)));
    }

    function setupMotion(root, attempt = 0) {
      if (root.dataset.motionReady === 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!window.gsap || !window.ScrollTrigger) {
        if (attempt < 120) window.setTimeout(() => setupMotion(root, attempt + 1), 50);
        return;
      }

      root.dataset.motionReady = 'true';
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);

      const story = root.querySelector('[data-cfp-story]');
      const storyCopy = root.querySelector('.cfp-story__copy');
      const storyVisual = root.querySelector('[data-cfp-story-visual]');
      const storyDevice = root.querySelector('[data-cfp-story-device]');
      const storyStatic = root.querySelector('[data-cfp-story-static]');
      const storyConditional = root.querySelector('[data-cfp-story-conditional]');
      const storyBrand = root.querySelector('[data-cfp-story-brand]');
      const storyStatus = root.querySelector('[data-cfp-story-status]');
      const storyMeter = root.querySelector('[data-cfp-story-meter]');
      const storyCaptions = Array.from(root.querySelectorAll('[data-cfp-story-caption]'));
      const mobileCardStories = Array.from(root.querySelectorAll('[data-cfp-card-story]'));
      const cardSectionMediaQuery = window.matchMedia('(max-width: 38rem)');
      const isMobileMotion = cardSectionMediaQuery.matches;

      const storyCopyFrom = isMobileMotion ? { autoAlpha: 0, y: 24 } : { autoAlpha: 0, y: 48, filter: 'blur(10px)' };
      const storyCopyTo = isMobileMotion ? { autoAlpha: 1, y: 0, duration: .55, stagger: .07, ease: 'power3.out' } : { autoAlpha: 1, y: 0, filter: 'blur(0px)', duration: 1, stagger: .11, ease: 'power4.out' };
      const storyVisualFrom = isMobileMotion ? { autoAlpha: 0, y: 24 } : { autoAlpha: 0, x: 60, rotateY: -8, scale: .92 };
      const storyVisualTo = isMobileMotion ? { autoAlpha: 1, y: 0, duration: .6, delay: .12, ease: 'power3.out' } : { autoAlpha: 1, x: 0, rotateY: 0, scale: 1, duration: 1.2, delay: .25, ease: 'power4.out' };
      gsap.fromTo(root.querySelectorAll('[data-cfp-story-copy]'), storyCopyFrom, storyCopyTo);
      gsap.fromTo(root.querySelector('[data-cfp-story-visual]'), storyVisualFrom, storyVisualTo);

      if (story && storyDevice && storyStatic && storyConditional && !isMobileMotion) {
        const mobileStory = false;
        gsap.set(storyConditional, { autoAlpha: 0 });
        gsap.set(storyCaptions, { autoAlpha: 0, y: 10 });
        if (storyCaptions[0]) gsap.set(storyCaptions[0], { autoAlpha: 1, y: 0 });

        const storyTimeline = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: story,
            start: 'top top',
            end: 'bottom bottom',
            scrub: 1
          },
          onUpdate: function () {
            const dynamic = this.progress() >= .5;
            if (storyBrand) storyBrand.textContent = dynamic ? storyBrand.dataset.dynamic : storyBrand.dataset.static;
            if (storyStatus) {
              storyStatus.textContent = dynamic ? storyStatus.dataset.dynamic : storyStatus.dataset.static;
              storyStatus.style.color = dynamic ? '#d9ff57' : '#ff6c79';
            }
          }
        });

        if (mobileStory) {
          storyTimeline
            .to(storyCopy, { autoAlpha: 0, y: -54, duration: .16, ease: 'power2.in' }, .1)
            .to(storyVisual, { y: () => -(window.innerHeight * .63 - 76), duration: .24, ease: 'power2.inOut' }, .1);
        }

        storyTimeline
          .to(storyMeter, { scaleX: 1, duration: 1 }, 0)
          .to(storyDevice, { rotateY: mobileStory ? -3 : -9, rotateX: mobileStory ? 1 : 3, scale: mobileStory ? .97 : .94, duration: .24 }, .08)
          .to(root.querySelectorAll('[data-cfp-story-static-field]'), { x: (index) => index % 2 ? (mobileStory ? 45 : 85) : (mobileStory ? -45 : -85), autoAlpha: .12, stagger: .025, duration: .22 }, .22)
          .to(storyCaptions[0], { autoAlpha: 0, y: -10, duration: .08 }, .3)
          .to(storyCaptions[1], { autoAlpha: 1, y: 0, duration: .1 }, .34)
          .to(storyStatic, { autoAlpha: 0, scale: .9, filter: 'blur(12px)', duration: .18 }, .4)
          .to(storyConditional, { autoAlpha: 1, scale: 1, filter: 'blur(0px)', duration: .2 }, .48)
          .from(root.querySelectorAll('[data-cfp-story-path]'), { y: 48, autoAlpha: 0, stagger: .08, duration: .22 }, .5)
          .to(storyDevice, { rotateY: mobileStory ? 3 : 7, rotateX: mobileStory ? -1 : -2, scale: mobileStory ? 1 : 1.025, duration: .24 }, .5)
          .to(storyCaptions[1], { autoAlpha: 0, y: -10, duration: .08 }, .67)
          .to(storyCaptions[2], { autoAlpha: 1, y: 0, duration: .1 }, .7)
          .to(storyDevice, { rotateY: 0, rotateX: 0, scale: 1, duration: .22 }, .78);
      } else if (story && storyConditional) {
        if (storyBrand) storyBrand.textContent = storyBrand.dataset.dynamic;
        if (storyStatus) {
          storyStatus.textContent = storyStatus.dataset.dynamic;
          storyStatus.style.color = '#d9ff57';
        }
      }

      const railLinks = Array.from(root.querySelectorAll('.cfp-rail a:not(.cfp-rail__brand)[href^="#"]'));
      let lockedRailHref = '';
      let unlockRailTimer;
      const setRailActive = (href, force = false) => {
        if (!force && lockedRailHref && href !== lockedRailHref) return;
        root.querySelectorAll('.cfp-rail a').forEach((item) => item.removeAttribute('aria-current'));
        const activeLink = root.querySelector(`.cfp-rail a[href="${href}"]`);
        if (activeLink && !activeLink.classList.contains('cfp-rail__brand')) activeLink.setAttribute('aria-current', 'true');
      };

      railLinks.forEach((link) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        ScrollTrigger.create({
          trigger: target,
          start: 'top 38%',
          end: 'bottom 38%',
          onToggle: (self) => {
            if (!self.isActive) return;
            setRailActive(link.getAttribute('href'));
          }
        });
      });

      root.querySelectorAll('a[href^="#cfp-"]').forEach((link) => {
        const href = link.getAttribute('href');
        const target = href === '#cfp-top' ? root : root.querySelector(href);
        if (!target) return;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          window.clearTimeout(unlockRailTimer);
          lockedRailHref = href;
          setRailActive(href, true);
          ScrollTrigger.refresh();

          window.requestAnimationFrame(() => {
            const destination = href === '#cfp-top' ? 0 : target.getBoundingClientRect().top + window.scrollY - 72;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: Math.max(0, destination), behavior: reducedMotion ? 'auto' : 'smooth' });
            const nextUrl = href === '#cfp-top' ? window.location.pathname + window.location.search : href;
            window.history.replaceState(null, '', nextUrl);
          });

          unlockRailTimer = window.setTimeout(() => {
            lockedRailHref = '';
            if (href !== '#cfp-top') setRailActive(href, true);
          }, 1800);
        });
      });
      if (!isMobileMotion) {
        gsap.to(root.querySelector('.cfp-ambient__orb--one'), { xPercent: -24, yPercent: 30, ease: 'none', scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: 1.2 } });
        gsap.to(root.querySelector('.cfp-ambient__orb--two'), { xPercent: 34, yPercent: -20, ease: 'none', scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: 1.2 } });
      }

      const tearDownMobileCardStories = () => {
        mobileCardStories.forEach((cardStory) => {
          if (cardStory.dataset.cfpCardStoryReady !== 'true') return;

          const cards = Array.from(cardStory.querySelectorAll('[data-cfp-card]'));
          const stage = cardStory.querySelector('[data-cfp-card-stage]');
          const timeline = cardStory._cfpCardTimeline;

          if (timeline) {
            timeline.scrollTrigger?.kill(true);
            timeline.kill();
            delete cardStory._cfpCardTimeline;
          }

          cardStory.classList.remove('is-cfp-pinned');
          cardStory.dataset.cfpCardStoryReady = 'false';

          gsap.set(cards, { clearProps: 'all', autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)' });
          cards.forEach((card, index) => gsap.set(card, { zIndex: index + 1 }));
          if (stage) gsap.set(stage, { clearProps: 'all' });
        });

        window.setTimeout(() => ScrollTrigger.refresh(), 50);
      };

      const setupMobileCardStories = () => {
        if (!cardSectionMediaQuery.matches) return;

        mobileCardStories.forEach((cardStory) => {
          const cardStage = cardStory.querySelector('[data-cfp-card-stage]');
          const cards = Array.from(cardStory.querySelectorAll('[data-cfp-card]'));
          if (!cardStage || cards.length < 2 || cardStory.dataset.cfpCardStoryReady === 'true') return;

          const storyHref = cardStory.id ? `#${cardStory.id}` : '';
          const keepStoryNavActive = () => {
            if (storyHref) setRailActive(storyHref);
          };

          cardStory.classList.add('is-cfp-pinned');
          gsap.set(cards, { autoAlpha: 0, y: 64, scale: .92, filter: 'blur(10px)' });
          cards.forEach((card, index) => gsap.set(card, { zIndex: index + 1 }));
          gsap.set(cards[0], { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)' });

          const cardTimeline = gsap.timeline({
            defaults: { ease: 'none' },
            scrollTrigger: {
              trigger: cardStory,
              start: 'top top',
              end: () => `+=${cards.length * window.innerHeight * .82}`,
              pin: true,
              pinSpacing: true,
              scrub: .65,
              anticipatePin: 1,
              invalidateOnRefresh: true,
              onEnter: keepStoryNavActive,
              onEnterBack: keepStoryNavActive,
              onUpdate: (self) => {
                if (self.isActive) keepStoryNavActive();
              }
            }
          });

          cards.forEach((card, index) => {
            if (index === 0) return;
            const previousCard = cards[index - 1];
            cardTimeline
              .to(previousCard, { autoAlpha: 0, y: -54, scale: .96, filter: 'blur(9px)', duration: .28 }, index)
              .fromTo(card, { autoAlpha: 0, y: 64, scale: .92, filter: 'blur(10px)' }, { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: .36 }, index + .06);
          });
          cardTimeline.to(cards[cards.length - 1], { scale: 1, duration: 1 }, cards.length);

          cardStory._cfpCardTimeline = cardTimeline;
          cardStory.dataset.cfpCardStoryReady = 'true';
        });

        window.setTimeout(() => ScrollTrigger.refresh(), 80);
      };

      const onCardSectionsChange = () => {
        tearDownMobileCardStories();
      };

      onCardSectionsChange();
      if (cardSectionMediaQuery.addEventListener) {
        cardSectionMediaQuery.addEventListener('change', onCardSectionsChange);
      } else {
        cardSectionMediaQuery.addListener(onCardSectionsChange);
      }

      root.querySelectorAll('[data-cfp-reveal]').forEach((element, index) => {
        if (element.hasAttribute('data-cfp-card') && element.closest('.is-cfp-pinned')) return;
        if (window.location.hash && element.getBoundingClientRect().top < window.innerHeight * 1.05) {
          gsap.set(element, { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)' });
          return;
        }
        const revealFrom = isMobileMotion ? { autoAlpha: 0, y: 24 } : { autoAlpha: 0, y: 54, scale: .985, filter: 'blur(9px)' };
        const revealTo = isMobileMotion ? { autoAlpha: 1, y: 0, duration: .5 } : { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: .9 };
        gsap.fromTo(element, revealFrom, { ...revealTo, delay: index % 3 * .04, ease: 'power3.out', scrollTrigger: { trigger: element, start: 'top 86%', toggleActions: 'play none none none' } });
      });

      if (window.location.hash) {
        window.setTimeout(() => {
          root.querySelectorAll('[data-cfp-reveal]').forEach((element) => {
            if (element.hasAttribute('data-cfp-card') && element.closest('.is-cfp-pinned')) return;
            const rect = element.getBoundingClientRect();
            if (rect.top < window.innerHeight * 1.05 && rect.bottom > 0) {
              gsap.set(element, { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)' });
            }
          });
        }, 400);
      }

      const visual = root.querySelector('[data-cfp-story-visual]');
      if (visual && window.matchMedia('(pointer: fine)').matches) {
        const consoleElement = visual.querySelector('[data-cfp-story-device]');
        const onMove = (event) => {
          const rect = visual.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          gsap.to(consoleElement, { rotateY: x * 7, rotateX: y * -6, duration: .5, ease: 'power2.out' });
        };
        const onLeave = () => gsap.to(consoleElement, { rotateY: 0, rotateX: 0, duration: .7, ease: 'power3.out' });
        visual.addEventListener('pointermove', onMove);
        visual.addEventListener('pointerleave', onLeave);
      }
    }

    function initialize(scope = document) {
      scope.querySelectorAll(selector).forEach((root) => {
        setupDemo(root);
        setupMotion(root);
      });
    }

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["otheriver-groupify"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-gfy-page]');
    const finishData = {
      oak: { className: 'gfy-finish-oak', url: '/products/arc-chair-oak', code: 'ARC / 01' },
      walnut: { className: 'gfy-finish-walnut', url: '/products/arc-chair-walnut', code: 'ARC / 02' },
      black: { className: 'gfy-finish-black', url: '/products/arc-chair-black', code: 'ARC / 03' },
      natural: { className: 'gfy-finish-natural', url: '/products/arc-chair-natural', code: 'ARC / 04' }
    };
    const finishClasses = Object.values(finishData).map((item) => item.className);

    function emit(name, detail) {
      const payload = Object.assign({ event: name, language: document.documentElement.lang || 'it' }, detail || {});
      window.dispatchEvent(new CustomEvent('otheriver:analytics', { detail: payload }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    }

    function setPressed(buttons, active) {
      buttons.forEach((button) => {
        const selected = button === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    roots.forEach((root) => {
      if (root.dataset.gfyReady === 'true') return;
      root.dataset.gfyReady = 'true';
      root.classList.add('is-gfy-ready');

      root.querySelectorAll('[data-gfy-track]').forEach((link) => {
        link.addEventListener('click', () => emit(link.dataset.gfyTrack, {
          placement: link.dataset.gfyPlacement || '',
          target: link.dataset.gfyTarget || '',
          url: link.href || ''
        }));
      });

      const navItems = Array.from(root.querySelectorAll('.gfy-nav a[href^="#"]'));
      const navLinks = navItems.filter((item) => !item.classList.contains('gfy-nav__brand'));
      const navBrand = navItems.find((item) => item.classList.contains('gfy-nav__brand'));
      let lockedNavHref = '';
      let unlockNavTimer;
      function setNavActive(href, force) {
        if (!force && lockedNavHref && href !== lockedNavHref) return;
        navItems.forEach((item) => item.removeAttribute('aria-current'));
        const activeLink = navItems.find((item) => item.getAttribute('href') === href);
        if (activeLink) activeLink.setAttribute('aria-current', 'true');
      }
      function updateNavActive() {
        if (lockedNavHref) return;
        const marker = window.innerHeight * .38;
        const current = navLinks.find((link) => {
          const target = root.querySelector(link.getAttribute('href'));
          if (!target) return false;
          const rect = target.getBoundingClientRect();
          return rect.top <= marker && rect.bottom >= marker;
        });
        if (current) {
          setNavActive(current.getAttribute('href'));
          return;
        }
        const firstTarget = navLinks[0] ? root.querySelector(navLinks[0].getAttribute('href')) : null;
        if (navBrand && firstTarget && firstTarget.getBoundingClientRect().top > marker) setNavActive(navBrand.getAttribute('href'));
      }
      root.querySelectorAll('.gfy-nav a[href^="#gfy-"]').forEach((link) => {
        const href = link.getAttribute('href');
        const target = href === '#gfy-top' ? root : root.querySelector(href);
        if (!target) return;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          window.clearTimeout(unlockNavTimer);
          lockedNavHref = href;
          setNavActive(href, true);
          window.requestAnimationFrame(() => {
            const destination = href === '#gfy-top' ? 0 : target.getBoundingClientRect().top + window.scrollY - 72;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: Math.max(0, destination), behavior: reducedMotion ? 'auto' : 'smooth' });
            const nextUrl = href === '#gfy-top' ? window.location.pathname + window.location.search : href;
            window.history.replaceState(null, '', nextUrl);
          });
          unlockNavTimer = window.setTimeout(() => {
            lockedNavHref = '';
            updateNavActive();
          }, 1800);
        });
      });
      updateNavActive();
      window.addEventListener('scroll', updateNavActive, { passive: true });
      window.addEventListener('resize', updateNavActive);

      const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;
      root.querySelectorAll('[data-gfy-reveal]').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));

      const story = root.querySelector('[data-gfy-story]');
      const stage = root.querySelector('[data-gfy-story-stage]');
      const statusText = stage ? [stage.dataset.statusOne, stage.dataset.statusTwo, stage.dataset.statusThree, stage.dataset.statusFour] : [];
      const storySteps = Array.from(root.querySelectorAll('[data-gfy-story-step]'));
      const progressBar = root.querySelector('[data-gfy-story-progress]');
      const storyStatus = root.querySelector('[data-gfy-story-status]');
      let previousStoryStep = -1;
      function updateStory() {
        if (!story || !stage || window.matchMedia('(max-width: 767px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const rect = story.getBoundingClientRect();
        const distance = Math.max(1, story.offsetHeight - window.innerHeight);
        const progress = Math.min(1, Math.max(0, -rect.top / distance));
        const step = Math.min(3, Math.floor(progress * 4));
        stage.dataset.step = String(step);
        storySteps.forEach((item, index) => item.classList.toggle('is-active', index === step));
        if (progressBar) progressBar.style.width = `${progress * 100}%`;
          if (storyStatus && statusText[step]) storyStatus.textContent = statusText[step];
        if (step !== previousStoryStep) {
          if (previousStoryStep >= 0) emit('groupify_demo_step', { step_id: `story_${step + 1}` });
          previousStoryStep = step;
        }
      }
      updateStory();
      window.addEventListener('scroll', updateStory, { passive: true });
      window.addEventListener('resize', updateStory);

      const demo = root.querySelector('[data-gfy-demo]');
      if (demo) {
        const preview = demo.querySelector('[data-gfy-preview]');
        const contextButtons = Array.from(demo.querySelectorAll('[data-gfy-context]'));
        const sourceButtons = Array.from(demo.querySelectorAll('[data-gfy-source]'));
        const deviceButtons = Array.from(demo.querySelectorAll('[data-gfy-device]'));
        const productButtons = Array.from(demo.querySelectorAll('[data-gfy-product]'));
        const swatches = Array.from(demo.querySelectorAll('[data-finish]'));
        const image = demo.querySelector('[data-gfy-demo-image]');
        const imagePhoto = demo.querySelector('[data-gfy-demo-photo]');
        const names = [demo.querySelector('[data-gfy-demo-name]'), demo.querySelector('[data-gfy-demo-name-two]')];
        const url = demo.querySelector('[data-gfy-demo-url]');
        const complete = demo.querySelector('[data-gfy-complete]');
        const demoStatus = demo.querySelector('[data-gfy-demo-status]');
        let started = false;

        function startDemo() {
          if (started) return;
          started = true;
          emit('groupify_demo_start', { placement: 'interactive_demo' });
        }
        function selectFinish(finish) {
          const data = finishData[finish];
          if (!data || !image) return;
          startDemo();
          image.classList.remove(...finishClasses);
          image.classList.add(data.className);
          image.querySelector('span').textContent = data.code;
          const productButton = demo.querySelector(`[data-gfy-product="${finish}"]`);
          const localizedName = productButton ? productButton.dataset.finishName : finish;
          if (imagePhoto && productButton && productButton.dataset.image) {
            imagePhoto.src = productButton.dataset.image;
            imagePhoto.alt = `Arc Chair — ${localizedName}`;
          }
          names.forEach((name) => { if (name) name.textContent = localizedName; });
          if (url) url.textContent = data.url;
          swatches.forEach((swatch) => swatch.classList.toggle('is-active', swatch.dataset.finish === finish));
          emit('groupify_demo_swatch_select', { finish, context: preview.dataset.context, swatch_source: preview.dataset.source });
        }
        contextButtons.forEach((button) => button.addEventListener('click', () => {
          startDemo(); setPressed(contextButtons, button); preview.dataset.context = button.dataset.gfyContext;
          emit('groupify_demo_context_change', { context: button.dataset.gfyContext });
        }));
        sourceButtons.forEach((button) => button.addEventListener('click', () => {
          startDemo(); setPressed(sourceButtons, button); preview.dataset.source = button.dataset.gfySource;
          emit('groupify_demo_step', { step_id: 'swatch_source', swatch_source: button.dataset.gfySource });
        }));
        deviceButtons.forEach((button) => button.addEventListener('click', () => {
          startDemo(); setPressed(deviceButtons, button); preview.dataset.device = button.dataset.gfyDevice;
          emit('groupify_demo_step', { step_id: 'device', device: button.dataset.gfyDevice });
        }));
        productButtons.forEach((button) => button.addEventListener('click', () => {
          startDemo(); const selected = button.classList.toggle('is-selected'); button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          const matchingSwatch = demo.querySelector(`[data-finish="${button.dataset.gfyProduct}"]`); if (matchingSwatch) matchingSwatch.hidden = !selected;
          emit('groupify_demo_step', { step_id: 'product_toggle', product: button.dataset.gfyProduct, selected });
        }));
        swatches.forEach((swatch) => swatch.addEventListener('click', () => selectFinish(swatch.dataset.finish)));
        if (complete) complete.addEventListener('click', () => {
          startDemo(); complete.textContent = complete.textContent.replace('→', '✓'); if (demoStatus) demoStatus.textContent = demoStatus.dataset.complete;
          emit('groupify_demo_complete', { context: preview.dataset.context, swatch_source: preview.dataset.source, device: preview.dataset.device });
        });
      }

      root.querySelectorAll('[data-gfy-faq]').forEach((details) => details.addEventListener('toggle', () => {
        if (details.open) emit('groupify_faq_open', { question_id: details.dataset.gfyFaq });
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["otheriver-private-apps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-private-apps]');

    const digest = async (value) => {
      const bytes = new TextEncoder().encode(value);
      const hash = await crypto.subtle.digest('SHA-256', bytes);
      return Array.from(new Uint8Array(hash), (byte) => byte.toString(16).padStart(2, '0')).join('');
    };

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const expectedHash = root.dataset.passwordHash;
      const gate = root.querySelector('[data-private-apps-gate]');
      const content = root.querySelector('[data-private-apps-content]');
      const form = root.querySelector('[data-private-apps-form]');
      const input = root.querySelector('[data-private-apps-password]');
      const error = root.querySelector('[data-private-apps-error]');
      const lock = root.querySelector('[data-private-apps-lock]');
      const storageKey = 'otheriver-private-apps-unlocked';

      const unlock = () => {
        gate.hidden = true;
        content.hidden = false;
        error.hidden = true;
        content.querySelector('a')?.focus({ preventScroll: true });
      };

      const relock = () => {
        sessionStorage.removeItem(storageKey);
        content.hidden = true;
        gate.hidden = false;
        form.reset();
        error.hidden = true;
        input.focus();
      };

      if (sessionStorage.getItem(storageKey) === expectedHash) unlock();

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        error.hidden = true;

        try {
          const enteredHash = await digest(input.value);
          if (enteredHash === expectedHash) {
            sessionStorage.setItem(storageKey, expectedHash);
            unlock();
            return;
          }
        } catch (exception) {
          console.warn('Private apps password verification is unavailable.', exception);
        }

        error.hidden = false;
        input.select();
      });

      lock.addEventListener('click', relock);

      const installButton = root.querySelector('[data-private-apps-install]');
      const installLabelEl = root.querySelector('[data-private-apps-install-label]');
      const installHint = root.querySelector('[data-private-apps-install-hint]');
      const installLabel = installLabelEl ? installLabelEl.textContent : '';
      const installedLabel = installButton ? installButton.dataset.installDoneLabel : '';
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
      const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
      let deferredPrompt = null;

      if (installButton && !isStandalone) {
        if (isIos) {
          installButton.hidden = false;
          installButton.addEventListener('click', () => {
            installHint.hidden = !installHint.hidden;
          });
        } else {
          window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            deferredPrompt = event;
            installButton.hidden = false;
          });

          installButton.addEventListener('click', async () => {
            if (!deferredPrompt) return;
            installButton.disabled = true;
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            deferredPrompt = null;
            if (outcome === 'accepted') {
              installLabelEl.textContent = installedLabel;
            } else {
              installButton.disabled = false;
            }
          });

          window.addEventListener('appinstalled', () => {
            installButton.hidden = true;
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
